var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "xr-create",
    {
      attrs: {
        loading: _vm.loading,
        title: _vm.title,
        "confirm-button-text": _vm.sureBtnTitle,
      },
      on: { close: _vm.close, save: _vm.saveClick },
    },
    [
      _c(
        "create-sections",
        { attrs: { title: "基本信息" } },
        [
          _c(
            "el-form",
            {
              ref: "crmForm",
              staticClass: "wk-form",
              attrs: {
                model: _vm.fieldForm,
                rules: _vm.fieldRules,
                "validate-on-rule-change": false,
                "label-position": "top",
              },
            },
            _vm._l(_vm.fieldList, function (children, index) {
              return _c("wk-form-items", {
                key: index,
                attrs: { "field-from": _vm.fieldForm, "field-list": children },
                on: { change: _vm.formChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ data }) {
                        return [
                          data && data.form_type == "customer"
                            ? _c("crm-relative-cell", {
                                attrs: {
                                  value: _vm.fieldForm[data.field],
                                  disabled: data.disabled,
                                  "relative-type": "customer",
                                },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          data &&
                          (data.form_type == "business" ||
                            data.form_type == "contacts")
                            ? _c("crm-relative-cell", {
                                attrs: {
                                  value: _vm.fieldForm[data.field],
                                  disabled: data.disabled,
                                  relation: data.relation,
                                  "relative-type": data.form_type,
                                },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          data && data.form_type == "product"
                            ? _c("xh-product", {
                                attrs: { value: _vm.fieldForm[data.field] },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpenExamine
        ? _c(
            "create-sections",
            { attrs: { title: "审核信息" } },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _vm.examineInfo.config === 1 || _vm.examineInfo.config === 0
                    ? _c("div", { staticClass: "examine-type" }, [
                        _vm._v(
                          _vm._s(
                            _vm.examineInfo.config === 1
                              ? "固定审批流"
                              : "授权审批人"
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.examineInfo && _vm.examineInfo.remark
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.examineInfo.remark,
                            effect: "dark",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "wk wk-help wk-help-tips",
                            staticStyle: { height: "13px" },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("create-examine-info", {
                ref: "examineInfo",
                attrs: { "types-id": _vm.action.id, types: "crm_contract" },
                on: { "value-change": _vm.examineValueChange },
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-button",
        {
          attrs: { slot: "footer", type: "primary", plain: "" },
          nativeOn: {
            click: function ($event) {
              return _vm.debouncedSaveField(true)
            },
          },
          slot: "footer",
        },
        [_vm._v("保存草稿")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }